/**
 * BreastPainBrief — iter1059 — компактна сводка от раздела „Болка в гърдата".
 * Рендира се само когато има данни, за да не трупа UI.
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { ArrowRight, Stethoscope } from "lucide-react";

export const BreastPainBrief = ({ isDark, context = "hormonal" }) => {
  const { API } = useAuth();
  const navigate = useNavigate();
  const [d, setD] = useState(null);

  useEffect(() => {
    axios.get(`${API}/breast-pain`)
      .then(({ data }) => setD(data))
      .catch(() => setD(null));
  }, [API]);

  if (!d || (!d.has_assessment && !d.diary?.has_data)) return null;

  const card = isDark ? "bg-slate-900/60 border-slate-800" : "bg-white border-slate-200";
  const box = isDark ? "bg-slate-800/50" : "bg-slate-100";
  const pattern = d.diary?.pattern;

  const why = context === "cortisol"
    ? "Кортизоловият превес сваля прага на болката — същият стимул се усеща по-силно и по-дълго. Затова болката в гърдата се чете и тук."
    : "Дневникът на болката се подрежда по фазите на цикъла — така се разделя цикличната мастодиния от болката в гръдната стена.";

  return (
    <div className={`p-4 rounded-2xl border ${card}`} data-testid="breast-pain-brief">
      <div className="flex items-center gap-2 mb-1">
        <Stethoscope className="w-4 h-4 text-pink-500" />
        <h3 className="font-bold text-sm flex-1">Болка в гърдата</h3>
        {d.red_flags?.triggered && (
          <span className="text-[10px] px-2 py-1 rounded-md font-bold bg-rose-600 text-white"
                data-testid="breast-pain-brief-flag">предупредителен признак</span>
        )}
      </div>

      <div className="flex flex-wrap gap-1.5 text-[10px] mb-2">
        {d.has_assessment && (
          <span className={`px-2 py-1 rounded-md ${box}`} data-testid="breast-pain-brief-verdict">
            {d.verdict.label_bg}
          </span>
        )}
        {pattern && (
          <span className={`px-2 py-1 rounded-md ${box}`} data-testid="breast-pain-brief-pattern">
            {pattern.label_bg}
          </span>
        )}
        {d.diary?.days_logged > 0 && (
          <span className={`px-2 py-1 rounded-md ${box}`}>
            {d.diary.days_logged} дни · средно {d.diary.avg_intensity ?? "—"}/10
          </span>
        )}
        {d.energy?.level !== "ok" && (
          <span className={`px-2 py-1 rounded-md ${box}`} data-testid="breast-pain-brief-energy">
            {d.energy.label_bg}
          </span>
        )}
      </div>

      <p className="text-[11px] opacity-75 leading-relaxed">{why}</p>

      <button onClick={() => navigate("/health-intelligence/breast")}
              className="mt-2 text-[11px] font-bold text-pink-500 hover:underline flex items-center gap-1"
              data-testid="breast-pain-brief-open">
        Отвори водения раздел <ArrowRight className="w-3 h-3" />
      </button>
    </div>
  );
};

export default BreastPainBrief;
